// extracted by mini-css-extract-plugin
export default {"container":"Item_container__XadnZ","labelItem":"Item_labelItem__fRqm2"};